"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = select_rc_b;
function select_rc_b(data, width, r, c) {
  return data[r * width + c];
}